import React, { useState, useEffect } from 'react';
import Row from '../Row';
import Form from '../Form';
import Button from '../Button';
import Col from '../Col';
import Input from '../Input';
import Checkbox from '../Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { addNewWalkthrough } from '../../store/actions/propertyWalkThroughForm';
import { clearValidation } from '../../store/actions/validation';
import Loader from '../Loader';
import Textarea from '../Textarea';

const AddWalkthrough = ({ userId, suiteId, roleName, onClose }) => {
  const [walkthroughName, setWalkthroughName] = useState('');
  const [description, setDescription] = useState('');
  const [walkthroughType, setWalkthroughType] = useState('');
  const [permissionType, setPermissionType] = useState('');
  const validation = useSelector((state) => state.validation);
  const loader = useSelector((state) => state.formLoader || false);
  const dispatch = useDispatch();

  const walkthroughTypes = ['Simplified', 'Enhanced'];
  const permissionTypes = ['Internal', 'Homeowner or Occupant'];

  useEffect(() => {
    if (validation.message === 'Saved') {
      dispatch(clearValidation());
      onClose();
    }
  }, [validation]);
  const onEditorChange = (description) => {
    setDescription(description);
  };
  const onAddWalkthrough = () => {
    let status = '';
    if (walkthroughType === 'Simplified' && permissionType === 'Internal') {
      status = 'Begin';
    } else if (
      walkthroughType === 'Simplified' &&
      permissionType === 'Homeowner or Occupant'
    ) {
      status = 'Activate';
    } else if (
      walkthroughType === 'Enhanced' &&
      permissionType === 'Internal'
    ) {
      status = 'Configure';
    } else {
      status = 'Configure';
    }
    const params = {
      walkthroughName: walkthroughName,
      description: description,
      walkthroughType: walkthroughType,
      permissions: permissionType,
      suiteId: suiteId,
      userId: userId,
      status: status,
    };
    dispatch(addNewWalkthrough(params, roleName));
  };
  return (
    <Form
      headline={'Add New Walkthrough'}
      onClose={onClose}
      actions={
        <>
          {loader && <Loader center={true} />}
          <Button
            color="teal"
            size="small"
            label="Save"
            disabled={
              !walkthroughName.trim() || !walkthroughType || !permissionType
            }
            onClick={onAddWalkthrough}
          />
        </>
      }
      component={
        <Row mdCenter>
          <Col xs="12" md="6">
            <Input
              value={walkthroughName}
              onChange={(e) => setWalkthroughName(e.target.value)}
              label="Name"
              placeholder="Name"
              required
              block
            />
            <Row>
              <Col xs="6" md="6">
                <label className="input__label" style={{ marginBottom: 12 }}>
                  Walkthrough Type:
                  <span className="input__required" />
                </label>
                <Row>
                  {walkthroughTypes.map((wt) => {
                    return (
                      <Col xs="12" md="6">
                        <Checkbox
                          value={walkthroughType === wt}
                          label={wt}
                          onChange={() => setWalkthroughType(wt)}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </Col>
              <Col xs="6" md="6">
                <label className="input__label" style={{ marginBottom: 12 }}>
                  Permissions:
                  <span className="input__required" />
                </label>
                <Row>
                  {permissionTypes.map((pm) => {
                    return (
                      <Col xs="12" md="6">
                        <Checkbox
                          value={permissionType === pm}
                          label={pm}
                          onChange={() => setPermissionType(pm)}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </Col>
            </Row>
            <Textarea
              value={description}
              onChange={(e) => onEditorChange(e.target.value)}
              label="Description"
              placeholder="Description"
              block
            />
          </Col>
        </Row>
      }
    />
  );
};
export default AddWalkthrough;
